export const LOAD_CUSTOMER = 'mp/movers/UNSERVICEABLE_LOAD_CUSTOMER';
export const DL_PAGE_LOADED = 'mp/movers/unserviceable/DL_PAGE_LOADED';

export const loadCustomer = () => {
  return {
    type: LOAD_CUSTOMER
  };
};



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/Movers/unserviceable/unserviceable.js
 **/